var fluxForm = {};

fluxForm.init = function() {
    this.onActiveField();

    jQuery( document.body ).on( 'country_to_state_changed', function () {
        fluxForm.onActiveField();
    } );
};

fluxForm.onActiveField = function() {
    var labels = document.querySelectorAll( '.flux-checkout--modern label:not( .checkbox )' );
    Array.from( labels ).forEach( function( label ) {
        var row = label.closest( '.form-row' );

        if ( ! row ) {
            return;
        }

        var input = row.querySelector( 'input' );

        if ( ! input ) {
            return;
        }

        if ( label.getAttribute( 'for') === 'billing_address_info' || label.getAttribute( 'for') === 'shipping_address_info' ) {
            row.classList.add( 'is-active' );
            return;
        }

        if ( input && input.value ) {
            row.classList.add( 'is-active' );
        } else {
            row.classList.remove( 'is-active' );
        }

        input.addEventListener( 'focus', function( e ) {
            row.classList.add( 'is-active' );
        });
        input.addEventListener( 'blur', function( e ) {
            if ( e.target.value ) {
                return;
            }
            row.classList.remove( 'is-active' );
        } );
        
        jQuery(input).change( function( e ) {
            if ( e.target.value ) {
                row.classList.add( 'is-active' );
            } else {
                row.classList.remove( 'is-active' );
            }
        });
    } );
};

export default fluxForm;